import React from 'react';
import { CSSTransition } from 'react-transition-group';
import { withRouter, Link } from 'react-router-dom';
import classNames from 'classnames';
import striptags from 'striptags';
import { find } from 'lodash';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import ArtistIntro from '../parts/artist_intro.jsx';
import isTouch from 'is-touch';

export class Photo extends React.Component {
  render() {
    const { colors, photos, title, suptitle, subtitle, to } = this.props;

    return <Link
      to={to}
      className={classNames('photo')}
      >
      <div className={classNames('photo__hover', {
          'photo__hover--always-show': isTouch
        })}>
        <div className="photo__hover__background"/>
        <div className="photo__hover__content" >
          {suptitle &&
            <div className="suptitle">
              {this.props.suptitle}
            </div>
          }
          <div className="title">
            {title}
          </div>
          {subtitle &&
            <div className="subtitle">
              <span className="name">
                {subtitle}
              </span>
            </div>
          }
        </div>
      </div>
      {photos[0] &&
        <img src={photos[0].sizes.large} />
      }
    </Link>;
  }
}

class Photographer extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      photographer: false,
      introHidden: false,
      informationShown: false
    };
  }

  componentDidMount(){
    setTimeout(() => {
      this.setState({introHiding: true});
      setTimeout(() => {
        this.setState({introHidden: true});
      }, 1000);
    }, 18 * 146);
  }

  componentDidUpdate(prevProps){
    if(
      (prevProps.photographers.length < this.props.photographers.length)
      ||
      (this.props.photographers.length > 0 && prevProps.photographers == this.props.photographers && !this.state.photographer)
    ) {
      const { photographers } = this.props;
      const photographer = find(photographers, { 'slug': this.props.match.params.slug });

      this.setState({
        photographer
      });
    }
  }

  _handleClick = () => {
    console.log('should handle click');
    this.setState({informationShown: !this.state.informationShown});
  }

  render () {
    const { location } = this.props;
    const { photographer } = this.state;
    const fromDetailView = this.props.location.state && this.props.location.state.fromDetailView;

    if(!photographer){
      return false;
    }

    return <div className={classNames('page page--artist page--photographer transition', {
        'page--artist--information': this.state.informationShown
      })} style={{backgroundColor: photographer.acf.secondary_color}}>
        <Helmet>
          <meta name='description' content={striptags(photographer.content.rendered)} />
          <meta name='og:description' content={striptags(photographer.content.rendered)} />
        </Helmet>
        <ArtistIntro
          hiding={this.state.introHiding}
          hidden={this.state.introHidden || fromDetailView}
          colors={{
            primary: photographer.acf.primary_color,
            secondary: photographer.acf.secondary_color,
            information: photographer.acf.information_text_color
          }}
          onLabelClick={() => this._handleClick()}
          artist={photographer}
        />
      <div className="artist__stream" style={{backgroundColor: photographer.acf.secondary_color}}>
          {photographer.acf && photographer.acf.jobs && photographer.acf.jobs.map((item, i) => {
            return <Photo
              key={i}
              to={`/photographers/${photographer.slug}/${i}/0`}
              colors={{primary: photographer.acf.primary_color, secondary: photographer.acf.secondary_color}}
              {...item}
              subtitle={item.client}
               />
          })}
        </div>
      </div>;
  }
}



const mapStateToProps = (state, ownProps) => {
  return {
    photographers: state.photographers.photographers
  }
}

export default withRouter(connect(mapStateToProps, null)(Photographer));
